import React from "react";

/**
 * UserMenuOptions is the UI containing the extra menu options added to the user
 * menu in the toolbar.
 */
export function UserMenuOptions() {
    return <></>;
}